import { NetworkStatus } from '@cbridge-utils/network';
import type { IMarkoutFilterOptionsData, IMarkoutStore } from './markout.interface';

export enum RiskLevel {
  Critical = 'CRITICAL',
  High = 'HIGH',
  Medium = 'MEDIUM',
  Low = 'LOW',
  All = 'ALL',
}

export const SELECTABLE_RISK_LEVELS: readonly RiskLevel[] = [
  RiskLevel.Critical,
  RiskLevel.High,
  RiskLevel.Medium,
  RiskLevel.Low,
];

export const DISPLAY_RISK_LEVELS: readonly RiskLevel[] = [
  RiskLevel.Critical,
  RiskLevel.High,
  RiskLevel.Medium,
  RiskLevel.Low,
  RiskLevel.All,
];

export const MARKOUT_INTERVALS_MS = [
  -2000, -1000, -500, -250, 250, 500, 1000, 2000, 5000, 10000, 30000,
] as const;

export type MarkoutIntervalMs = typeof MARKOUT_INTERVALS_MS[number];

export const MARKOUT_FINAL_SCORE_MAX = 11;

export const MARKOUT_ROW_ID_SEPARATOR = ':';

export const CURRENT_DAY_REPORT_ID = 0;

export enum MarkoutClassificationCategory {
  Verified = 'VERIFIED',
  Hidden = 'HIDDEN',
}

export enum MarkoutGridView {
  Default = 'DEFAULT',
  Verified = 'VERIFIED',
  Hidden = 'HIDDEN',
}

export const MARKOUT_GRID_VIEWS: readonly MarkoutGridView[] = [
  MarkoutGridView.Verified,
  MarkoutGridView.Default,
  MarkoutGridView.Hidden,
];

export enum JobStatus {
  Done = 'DONE',
  Failed = 'FAILED',
  InProcess = 'IN_PROCESS',
  Pending = 'PENDING',
  Stopped = 'STOPPED',
}

export const JOB_STATUSES: readonly JobStatus[] = [
  JobStatus.Done,
  JobStatus.Failed,
  JobStatus.InProcess,
  JobStatus.Stopped,
];

export enum PriceType {
  Tob = 'TOB',
}

export enum Side {
  Buy = 'BUY',
  Sell = 'SELL',
}

export enum TradeSide {
  Both = 'BOTH',
  Buy = 'BUY',
  Sell = 'SELL',
}

export const TRADE_SIDES: readonly TradeSide[] = [
  TradeSide.Both,
  TradeSide.Buy,
  TradeSide.Sell,
];

export enum ReportRangePreset {
  LastDay = 'LAST_DAY',
  LastWeek = 'LAST_WEEK',
  LastMonth = 'LAST_MONTH',
  Custom = 'CUSTOM',
}

export const REPORT_RANGE_PRESETS: readonly ReportRangePreset[] = [
  ReportRangePreset.LastDay,
  ReportRangePreset.LastWeek,
  ReportRangePreset.LastMonth,
  ReportRangePreset.Custom,
];

export enum MinNotional {
  Gt0 = 0,
  Gt10K = 10000,
  Gt25K = 25000,
  Gt50K = 50000,
}

export const MIN_NOTIONAL_OPTIONS: readonly MinNotional[] = [
  MinNotional.Gt0,
  MinNotional.Gt10K,
  MinNotional.Gt25K,
  MinNotional.Gt50K,
];

export const EMPTY_FILTER_OPTIONS: IMarkoutFilterOptionsData = {
  servers: [],
  accountGroups: [],
  accounts: [],
  symbols: [],
};

export const markoutInitialState: IMarkoutStore = {
  reports: [],
  reportsNetworkStatus: NetworkStatus.None,
  reportsListRevision: 0,
  reportsRetrying: false,
  dashboard: null,
  dashboardDataRevision: 0,
  data: null,
  dataTarget: null,
  dataNetworkStatus: NetworkStatus.None,
  dataFiltered: false,
  reportDataRevision: 0,
  dataRetrying: false,
  symbols: null,
  symbolsTarget: null,
  symbolsNetworkStatus: NetworkStatus.None,
  filterOptionsByTarget: {},
  formSymbolsByServer: {},
};
